// Note: this is only temporary until the smart compose library exports these types.
export enum MailboxType {

    UserMailbox = 1,
    GroupMailbox,
    Unknown,
}

/**
 * @codegen
 */
export interface Recipient {
    a?: string;
    n?: string;
    t?: MailboxType;
}

export interface Envelope {
    user: Recipient;
    constraints: string;
    subject?: string;
    to?: Recipient[];
    cc?: Recipient[];
    bcc?: Recipient[];
    emailReferenceId?: string;
}
